export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const FORM_NAME = 'orders-planning-modal';

export const REQUIRED_FIELDS = [
	'config_id',
	'transport_type_id',
	'transport_count',
	'weight',
	'volume',
	'work_time_from',
	'work_time_to',
	'pickup_time_from',
	'pickup_time_to',
	'drop_time_from',
	'drop_time_to',
	'compatibilities',
];

export const REQUIRED_WITH_AUTOPARK_FIELDS = [
	'config_id',
	'autopark_ids',
	'tariff_type_id',
	'work_time_from',
	'work_time_to',
	'pickup_time_from',
	'pickup_time_to',
	'drop_time_from',
	'drop_time_to',
	'compatibilities',
];

export const FORM_FIELDS = [
	'config_id',
	'autopark_ids',
	'tariff_type_id',
	'transport_type_id',
	'transport_count',
	'weight',
	'volume',
	'weight_recycling_rate',
	'volume_recycling_rate',
	'weight_rate',
	'volume_rate',
	'points_amount',
	'work_time_from',
	'work_time_to',
	'pickup_time_from',
	'pickup_time_to',
	'pickup_time',
	'drop_time_from',
	'drop_time_to',
	'drop_time',
	'compatibilities',
];

export const COMPATIBILITIES_REQUIRED_FIELDS = ['mode_id', 'compatibility'];
